"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _LayerRenderer2 = _interopRequireDefault(require("./LayerRenderer"));

var _LayerTransformData = _interopRequireDefault(require("../layers/LayerTransformData"));

var _CreativeLayer = _interopRequireDefault(require("../../models/creative/CreativeLayer"));

var _Rectangle = _interopRequireDefault(require("../../models/geometry/Rectangle"));

var _isEmpty = _interopRequireDefault(require("../../utils/array/isEmpty"));

var _deepEqual = _interopRequireDefault(require("../../utils/object/deepEqual"));

var _setImageSmoothing = _interopRequireDefault(require("../../utils/canvas/setImageSmoothing"));

var _creative = require("../../constants/creative");

var _BitmapFrameData = _interopRequireDefault(require("../store/BitmapFrameData"));

var _BaseRenderer = _interopRequireDefault(require("./BaseRenderer"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var GroupRenderer = /*#__PURE__*/function (_LayerRenderer) {
  (0, _inherits2["default"])(GroupRenderer, _LayerRenderer);

  var _super = _createSuper(GroupRenderer);

  /** @type {CanvasFactory} */

  /** @type {{dimensions: Rectangle, imageSmoothing: Boolean}} */

  /** @type {Map} */

  /** @type {Rectangle} Canvas's dimensions */

  /**
   * Group Renderer
   * @param creativeLayer {CreativeLayer | null}
   * @param contentStore {ContentStore}
   * @param layerTransformer {LayerTransformer}
   * @param filterProcessor {FilterProcessor}
   * @param layerRendererCache {LayerRendererCache}
   * @param canvasFactory {CanvasFactory}
   * @param canvasOptions {{dimensions: Rectangle, imageSmoothing: Boolean}}
   */
  function GroupRenderer(creativeLayer, contentStore, layerTransformer, filterProcessor, layerRendererCache, canvasFactory, canvasOptions) {
    var _this;

    (0, _classCallCheck2["default"])(this, GroupRenderer);
    var groupDimensions = canvasOptions.dimensions,
        imageSmoothing = canvasOptions.imageSmoothing;

    if (!_Rectangle["default"].isValidRectangle(groupDimensions)) {
      throw new Error('Group dimensions must be provided for Group Renderer as group does not have explicit width and height');
    }

    _this = _super.call(this, creativeLayer, contentStore, layerTransformer, filterProcessor);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_canvasFactory", null);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_canvasOptions", {});
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_childLayers", null);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_groupDimensions", null);
    _this._childLayers = new Map();
    _this._layerRendererCache = layerRendererCache;
    _this._canvasFactory = canvasFactory;
    _this._canvasOptions = canvasOptions;
    _this._groupDimensions = groupDimensions;
    var height = groupDimensions.height,
        width = groupDimensions.width;
    var canvas = canvasFactory.getCanvas({
      height: height,
      width: width
    });
    var context = canvas.getContext('2d'); // Set image smoothing

    (0, _setImageSmoothing["default"])(context, Boolean(imageSmoothing));
    _this._layerBitmap = canvas;
    _this._context = context;
    _this._contentTransformMode = _BaseRenderer["default"].TRANSFORM_PASSTHROUGH;
    return _this;
  }

  (0, _createClass2["default"])(GroupRenderer, [{
    key: "clearAll",
    value: function clearAll() {
      /*
      Assumes the current context is translated correctly as per the constructor
       */
      var _this$_groupDimension = this._groupDimensions,
          canvasHeight = _this$_groupDimension.height,
          canvasWidth = _this$_groupDimension.width;

      this._context.clearRect(0, 0, canvasWidth, canvasHeight);
    }
  }, {
    key: "_getChildLayers",
    value: function _getChildLayers() {
      var childLayers = new Map();

      this._creativeLayer.children.forEach(function (childLayer) {
        if (!childLayer.loaded || !_CreativeLayer["default"].isVisibleCreativeLayer(childLayer)) return;
        childLayers.set(childLayer.elementId, childLayer);
      });

      return childLayers;
    }
  }, {
    key: "_getLayerRendererList",
    value: function _getLayerRendererList(creativeLayers) {
      var _this2 = this;

      var layerRenderers = [];
      creativeLayers.forEach(function (creativeLayer) {
        var layerRenderer = _this2._layerRendererCache.getRenderer(creativeLayer, _this2._contentStore, _this2._layerTransformer, _this2._filterProcessor, _this2._canvasFactory, _this2._canvasOptions);

        layerRenderers.push(layerRenderer);
      });
      return layerRenderers;
    }
  }, {
    key: "_drawGroupChildren",
    value: function _drawGroupChildren(layerRendererList, currentFrame) {
      var _this3 = this;

      layerRendererList.forEach(function (layerRenderer, index) {
        if (!layerRenderer) {
          return;
        }

        var layerData = layerRenderer.getLayerTransformData(currentFrame);

        if (!layerData) {
          return;
        }

        if (!layerData.visible) {
          return;
        }

        layerRenderer.renderLayer(_this3._context, currentFrame, _this3._groupDimensions);
      });
    }
  }, {
    key: "getContentFrameData",
    value: function getContentFrameData(frameNum) {
      // TODO optimize this?
      // TODO GroupFrameData with child layers, would help clean up shouldDrawNewFrame
      return new _BitmapFrameData["default"](this._layerBitmap, this._groupDimensions.width, this._groupDimensions.height);
    }
  }, {
    key: "getLayerBitmap",
    value: function getLayerBitmap(currentFrame) {
      if (!this.shouldDrawNewFrame(currentFrame)) {
        return this._layerBitmap;
      }

      this.clearAll(); // Get list of child element ids

      this._childLayers = this._getChildLayers(); // If elements is empty, return an empty rectangle;

      if (this._childLayers.size === 0) {
        return this._layerBitmap;
      } // Get the layer data from each element in the list.


      var layerRendererList = this._getLayerRendererList(this._childLayers);

      if ((0, _isEmpty["default"])(layerRendererList)) {
        return this._layerBitmap;
      } // Draw the layers to the local group canvas


      this._drawGroupChildren(layerRendererList, currentFrame); // Draw the group canvas to the provided context.


      return this._layerBitmap;
    }
  }, {
    key: "_calculateLayerTransformData",
    value: function _calculateLayerTransformData(frameNum) {
      if (!this._creativeLayer) return null;

      var visible = this._creativeLayer.isVisibleForFrame(frameNum);

      var alphaCompositeRule = this._creativeLayer.alphaCompositeRule; // Set defaults for Groups, since children of groups already account for group transformations.
      // TODO consider making this part of the drawing part?

      var _this$_groupDimension2 = this._groupDimensions,
          canvasHeight = _this$_groupDimension2.height,
          canvasWidth = _this$_groupDimension2.width;
      return new _LayerTransformData["default"](this.contentDimensionMode, 0, 0, canvasWidth, canvasHeight, this.contentScaleX, this.contentScaleY, null, null, null, null, alphaCompositeRule, visible, _creative.DEFAULT_KEYFRAME_TRANSFORM.filters);
    }
  }, {
    key: "shouldDrawNewFrame",
    value: function shouldDrawNewFrame(frameNum) {
      var superShouldDraw = (0, _get2["default"])((0, _getPrototypeOf2["default"])(GroupRenderer.prototype), "shouldDrawNewFrame", this).call(this, frameNum);
      if (superShouldDraw) return true;

      var childLayers = this._getChildLayers();

      if (!(0, _deepEqual["default"])(childLayers, this._childLayers)) return true; // Get the layer data from each element in the list.

      var canvasRendererList = this._getLayerRendererList(childLayers);

      var shouldDraw = canvasRendererList.some(function (layerBitmap) {
        return layerBitmap && layerBitmap.shouldDrawNewFrame(frameNum);
      });
      return shouldDraw;
    }
  }]);
  return GroupRenderer;
}(_LayerRenderer2["default"]);

exports["default"] = GroupRenderer;